import styled from 'styled-components';
import { FONT_WEIGHT_BOLD, MAIN_COLOR, GRAY_LIGHTER, FONT_SIZE_5 } from '../../../styles/variables';
import { flexPosition, fontStyle } from '../../../styles/mixins';

export const Item = styled.li`
  ${fontStyle(MAIN_COLOR, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
  list-style: none;
  border-bottom: ${({ lastItem }) => (!lastItem ? `1px solid ${GRAY_LIGHTER}` : 'none')};
`;

export const Button = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  outline: none;
`;

export const Text = styled.span``;

export const SubItemWrapper = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  transition: all 0.4s;
  overflow: hidden;
`;

export const TitleAccordion = styled.div`
  width: 100%;
  padding: 0px 10px 0px 10px;
  height: 50px;
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  .checkbox {
    margin-right: 5px;
  }
`;

export const AccordionName = styled.div`
  ${flexPosition({ align: 'center' })}
`;

export const CustomCheckAll = styled.i`
  width: 18px;
  height: 18px;
  border: 2px solid ${GRAY_LIGHTER};
  background-color: ${({ disabled }) => (disabled ? GRAY_LIGHTER : '#fff')};
  border-radius: 3px;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  ${props =>
    props.someChecked
      ? `
    border-color: ${MAIN_COLOR};
    background-color: ${MAIN_COLOR};
    &:after {
      content: '';
      background-color: #FFF;
      width: 12px;
      height: 2px;
      border-radius: 3px;
      display: flex;
      position: absolute;
      top: 45%;
      left: 1px;
    }
  `
      : null}
  ${props =>
    props.allChecked
      ? `
    &:after {
      top: 0;
      left: 4px;
      background-color: transparent;
      border-radius: 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
      height: 12px;
      width: 6px;
      border-bottom: 2px solid #FFF;
      border-right: 2px solid #FFF;
    }
  `
      : null}
`;



// WEBPACK FOOTER //
// ./src/components/GenericList/Accordion/style.js